// extracted by mini-css-extract-plugin
module.exports = {"tableHead":"Table_tableHead__1JD3H","bigColWidth":"Table_bigColWidth__3ZTjk","biggerColWidth":"Table_biggerColWidth__17aP0","row":"Table_row__3kGz4","col":"Table_col__2hFrl"};